// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3007":"ffb764d2","5665":"504c0dd5","9221":"0b38d5ce"}[chunkId] + ".chunk.css";
};